import React, { useState } from 'react'

import {
  AllItemsCheckbox,
  ItemsActionsDropdown,
  ItemsActionsProvider,
  Pagination,
  RItem,
  SearchLabels,
  buildQs,
  parser,
  useConfig,
  useLocation,
  useTraversal,
} from '@guillotinaweb/react-gmi'
import { useEffect } from 'react'
import useSetState from '../../common/useSetState'

const initialState = {
  page: 0,
  items: [],
  loading: true,
  total: 0,
}

export function HomeItems(props) {
  const [location, setLocation] = useLocation()
  const { PageSize } = useConfig()

  const Ctx = useTraversal()
  const [state, setState] = useSetState(initialState)

  const { items, loading, total } = state
  const [sortedItems, setSortedItems] = useState([])

  const columns = Ctx.client.getItemsColumn(items, Ctx.path)

  let search = location.get('q')
  let page

  try {
    page = parseInt(location.get('page')) || 0
  } catch {
    page = 0
  }

  let searchParsed = undefined
  if (search && search !== '') {
    searchParsed = parser(search)
  }

  useEffect(() => {
    if (Ctx.state.loading) return
    ;(async () => {
      let data
      setState({ loading: true, total: Ctx.context.length })
      if (search) {
        let qs = buildQs(searchParsed)

        data = await Ctx.client.search(
          Ctx.path,
          qs,
          false,
          false,
          page * PageSize,
          PageSize
        )
      } else {
        data = await Ctx.client.getItems(Ctx.path, page * PageSize, PageSize)
      }
      setState({
        items: data.member,
        loading: false,
        total: data.items_count,
      })
      setSortedItems(data.member)
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, Ctx.state.refresh, page])

  const doPaginate = (page) => {
    setLocation({ page: page })
  }

  return (
    <ItemsActionsProvider items={sortedItems}>
      <div className="columns">
        <div className="column is-2 is-size-7">
          <ItemsActionsDropdown />
        </div>
        <div className="column">
          <SearchLabels />
        </div>
        <div className="column">
          <Pagination
            current={page}
            total={total}
            key="pagination-top"
            doPaginate={doPaginate}
            pager={PageSize}
          />
        </div>
      </div>
      {loading && <div className="progress-line"></div>}
      {!loading && (
        <table className="table is-fullwidth is-hoverable">
          <thead className="is-size-7">
            <tr>
              <th>
                <AllItemsCheckbox />
              </th>
              {columns.map((i) => (
                <th key={i.label} className="has-text-info">
                  {i.label}
                </th>
              ))}
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            {sortedItems &&
              sortedItems.map((item) => {
                return (
                  <RItem
                    item={item}
                    setPath={Ctx.setPath}
                    key={item['@uid']}
                    search={search}
                    columns={columns}
                  />
                )
              })}
            {sortedItems && sortedItems.length === 0 && (
              <tr>
                <td colSpan="6" className="has-text-centered">
                  Anything here!
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
      <div className="columns is-centered">
        <Pagination
          current={page}
          key="pagination-bottom"
          total={total}
          doPaginate={doPaginate}
          pager={PageSize}
        />
      </div>
    </ItemsActionsProvider>
  )
}
